module.exports = __webpack_public_path__ + "static/videos/woodcut_draw001.5fd9acb.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/woodcut/woodcut_draw001.mp4
// module id = 477
// module chunks = 1